module.exports = __webpack_public_path__ + "static/media/30.e3813382.jpeg";